import React from 'react';
import './App.css';
const LOGO = "https://avatars2.githubusercontent.com/u/5319523?s=400&u=dc24adb982d0ba744798354333da27ceb79fe326&v=4";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={LOGO} className="Profile-pix" alt="logo" />
        <p className="code intro">Hi, I am Alfred Ayi-Bonte. I am a Mathematician, and a Software developer from Ghana.</p>
        <p className="social-media-link">
          <a className="code" href="https://github.com/alfredayibonte" target="_blank" rel="noopener noreferrer">Github</a>
          <a className="code" href="https://twitter.com/alfredayibonte" target="_blank" rel="noopener noreferrer">Twitter</a>
          <a className="code" href="https://www.linkedin.com/in/alfredayibonte" target="_blank" rel="noopener noreferrer">Linkedin</a>
        </p>
      </header>
      <footer>
        <p>Feel free to reach out to me at &nbsp;
          <a className="code" href="mailto:alfredayibonte@gmail.com" target="_blank" rel="noopener noreferrer">alfredayibonte@gmail.com</a>
        </p>
      </footer>
    </div>
  );
}
export default App;
